import { Component } from '@angular/core'

const setup = `pnpm run setup`
const start = `pnpm start-setup`
const startDev = `pnpm start-setup:dev`

@Component({
  selector: 'se-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss'],
  standalone: false,
})
export class OverviewComponent {

  public code = {
    setup,
    start,
    startDev
  }
}
